<template>
    <div class="analytics-phone-completion" :class="typeClass()">
        <div
            v-for="phone in phones[type]" :key="phone.id"
            class="analytics-phone-completion__wr-phone"
            :class="completionClass(phone)"
            :data-phoneid="phone.id - 1">
            <div class="analytics-phone-completion__wr-phone-icon">
                <span class="analytics-phone-completion__phone-icon"></span>
            </div>
            <div class="analytics-phone-completion__phone">
                <div v-if="showPreloader" class="analytics-phone-completion__preloader"></div>
                <template v-if="!showPreloader">
                    <span class="analytics-phone-completion__phone-label">{{ textPhoneLabel() }}</span>
                    <span class="analytics-phone-completion__phone-value">{{ textPhoneValue(phone) }}</span>
                    <div class="analytics-phone-completion__phone-correctness">
                        <span class="analytics-phone-completion__correctness-label">DOĞRULUK</span>
                        <div class="analytics-phone-completion__wr-correctness-value">
                            <span v-if="showCorrectnessIcon(phone)" class="analytics-phone-completion__correctness-icon"></span>
                            <span class="analytics-phone-completion__correctness-value">{{ phone.correctness }}/100</span>
                        </div>
                    </div>
                    <span class="analytics-phone-completion__progressbar"></span>
                </template>
                    <span class="analytics-phone-completion__phone-border"></span>
            </div>
        </div>
    </div>
</template>
<script>
    import {animate, createTimeline} from 'animejs';
    
    export default {
        props: {
            showPreloader: {
                type: Boolean,
                default: true
            },
            
            type: {
                type: String,
                default: 'phonemicVowel',
            },

            phones: {
                type: Object,
                default: {
                    phonemicVowel: [
                        {id: 1, value: "/a/", correctness: 100},
                        {id: 2, value: "/e/", correctness: 0},
                        {id: 3, value: "/o/", correctness: 0},
                        {id: 4, value: "/ö/", correctness: 0},
                        {id: 5, value: "/ı/", correctness: 0},
                        {id: 6, value: "/i/", correctness: 0},
                        {id: 7, value: "/u/", correctness: 0},
                        {id: 8, value: "/ü/", correctness: 0}
                    ],
                    phonemicConsonant: [
                        {id: 1, value: "/p/", correctness: 100},
                        {id: 2, value: "/b/", correctness: 0},
                        {id: 3, value: "/t/", correctness: 0},
                        {id: 4, value: "/d/", correctness: 0},
                        {id: 5, value: "/k/", correctness: 0},
                        {id: 6, value: "/g/", correctness: 0},
                        {id: 7, value: "/f/", correctness: 0},
                        {id: 8, value: "/v/", correctness: 0},
                        {id: 9, value: "/s/", correctness: 0},
                        {id: 10, value: "/z/", correctness: 0},
                        {id: 11, value: "/ş/", correctness: 0},
                        {id: 12, value: "/j/", correctness: 0},
                        {id: 13, value: "/h/", correctness: 0},
                        {id: 14, value: "/y/", correctness: 0},
                        {id: 15, value: "/m/", correctness: 0},
                        {id: 16, value: "/n/", correctness: 0},
                        {id: 17, value: "/r/", correctness: 0},
                        {id: 18, value: "/l/", correctness: 0},
                        {id: 19, value: "/ç/", correctness: 0},
                        {id: 20, value: "/c/", correctness: 0}
                    ],
                    phoneticVowel: [
                        {id: 1, value: "[ɑ]", correctness: 100},
                        {id: 2, value: "[a]", correctness: 0},
                        {id: 3, value: "[e]", correctness: 0},
                        {id: 4, value: "[ɛ]", correctness: 0},
                        {id: 5, value: "[æ]", correctness: 0},
                        {id: 6, value: "[o]", correctness: 0},
                        {id: 7, value: "[ɔ]", correctness: 0},
                        {id: 8, value: "[ø]", correctness: 0},
                        {id: 9, value: "[œ]", correctness: 0},
                        {id: 10, value: "[ɨ]", correctness: 0},
                        {id: 11, value: "[i]", correctness: 0},
                        {id: 12, value: "[ɪ]", correctness: 0},
                        {id: 13, value: "[u]", correctness: 0},
                        {id: 14, value: "[ʊ]", correctness: 0},
                        {id: 15, value: "[y]", correctness: 0},
                        {id: 16, value: "[ʏ]", correctness: 0}
                    ],
                    phoneticConsonant: [
                        {id: 1, value: "[k]", correctness: 100},
                        {id: 2, value: "[c]", correctness: 0},
                        {id: 3, value: "[g]", correctness: 0},
                        {id: 4, value: "[ɟ]", correctness: 0},
                        {id: 5, value: "[v]", correctness: 0},
                        {id: 6, value: "[ʋ]", correctness: 0},
                        {id: 7, value: "[z]", correctness: 0},
                        {id: 8, value: "[z̥]", correctness: 0},
                        {id: 9, value: "[x]", correctness: 0},
                        {id: 10, value: "[ç]", correctness: 0},
                        {id: 11, value: "[m]", correctness: 0},
                        {id: 12, value: "[ɱ]", correctness: 0},
                        {id: 13, value: "[n]", correctness: 0},
                        {id: 14, value: "[ŋ]", correctness: 0},
                        {id: 15, value: "[r]", correctness: 0},
                        {id: 16, value: "[ɾ]", correctness: 0},
                        {id: 17, value: "[ɣ]", correctness: 0},
                        {id: 18, value: "[ɬ]", correctness: 0},
                        {id: 19, value: "[l]", correctness: 0}
                    ]
                }
            }
        },

        watch: {
            // This watcher makes sure that upon request completion animations are
            // triggered for the set of wr-phone elements that is already in viewport
            // scrolled by user. 
            showPreloader(nv, ov){
                // If showPreloader's nv is true there is not element to query.
                if(nv){
                    return;
                }
                this.$nextTick(() => {
                    let observer = new IntersectionObserver((entries, obs) => {
                        entries.forEach(entry => {
                            if(entry.isIntersecting){
                                this.animatePhoneIcon(entry.target);
                                this.animatePhoneValue(entry.target);
                                this.animateProgresbar(entry.target);
                            }
                        });
                        obs.disconnect();
                    }, {threshold: 1.0});

                    document.querySelectorAll(`.analytics-phone-completion.${this.typeClass()} .analytics-phone-completion__wr-phone`).forEach((elPhone, idx) => {
                        observer.observe(elPhone);
                    });
                });
            }
        },

        methods: {
            showCorrectnessIcon(phone){
                return phone.correctness === 100;
            },

            textPhoneLabel(){
                if(this.type.includes('phonemic')){
                    return 'SESBİRİM';
                }
                else if(this.type.includes('phonetic')){
                    return 'SESBİRİMCİK';
                }
            },

            textPhoneValue(phone){
                if(this.type === 'phoneticConsonant' && phone.id === 8){
                    return '[ z̥ ]';
                }
                return `${phone.value[0]} ${phone.value[1]} ${phone.value[2]}`;
            },

            typeClass(){
                return `analytics-phone-completion--${this.type.slice(0, 8)}-${this.type.slice(8).toLowerCase()}`;
            },

            completionClass(phone){
                return phone.correctness === 100
                       ? 'analytics-phone-completion--completed-phone'
                       : '';
            },

            animatePhoneValue(elPhone){
                if(this.showPreloader){
                    return;
                }
                if(!elPhone.classList.contains('analytics-phone-completion--completed-phone')){
                    return;
                }
                let elPhoneValue = elPhone.querySelector('.analytics-phone-completion__phone-value');
                animate(elPhoneValue, {
                    color: 'rgba(39, 121, 237, 0.75)',
                });
            },

            animateProgresbar(elPhone){
                if(this.showPreloader){
                    return;
                }
                let correctness = 100 - this.phones[this.type][elPhone.dataset.phoneid].correctness;
                let elProgressbar = elPhone.querySelector(".analytics-phone-completion__progressbar");
                animate(elProgressbar, {delay: 500, backgroundSize: `0.7px 100%, 0.7px 100%, 0.7px 100%, ${correctness}% 100%, auto`});
            },

            animatePhoneIcon(elPhone){
                if(this.showPreloader){
                    return;
                }
                if(!elPhone.classList.contains('analytics-phone-completion--completed-phone')){
                    return;
                }
                let elPhoneIcon = elPhone.querySelector('.analytics-phone-completion__phone-icon');
                createTimeline()
                .add(elPhoneIcon, {
                        y: -30,
                        opacity: 0,
                        delay: 150,
                        duration: 500,
                        onComplete: jsAnimation => jsAnimation.targets.forEach(el => el.classList.add('analytics-phone-completion__phone-icon-diamond'))
                })
                .add(elPhoneIcon, {
                        y: 0,
                        opacity: 1,
                        duration: 500
                });
            },
        },

        mounted(){
            let observerOptions = {
                threshold: 1.0
            };
            let observer = new IntersectionObserver((entries, obs) => {
                entries.forEach(entry => {
                    let elPhone = entry.target;
                    if(entry.isIntersecting){
                        this.animatePhoneValue(elPhone);
                        this.animateProgresbar(elPhone);
                        this.animatePhoneIcon(elPhone);
                        obs.unobserve(elPhone);
                    }
                })
            }, observerOptions);
            document.querySelectorAll(`.analytics-phone-completion.${this.typeClass()} .analytics-phone-completion__wr-phone`).forEach((el, idx) => {
              observer.observe(el);  
            })
        }
    };
</script>
<style scoped src="@/css/components/analytics-phone-completion.css"></style>